<template>
  <div class="textarea-counted-container">
    <input
      :id="inputName"
      type="text"
      class="textarea-counted"
      v-model="localValue" />
    <div v-if="basicValue.length > 1" class="basic-output">
      Username: {{ basicValue[0] }}
      <br />
      Password: {{ basicValue[1] }}
    </div>
  </div>
</template>
<script>
import { randomHex } from '../utils';

export default {
  name: 'TextareaCounted',
  props: {
    inputName: {
      type: String,
      default: () => randomHex(5),
    },
  },
  data: function() {
    return {
      localValue: '',
    };
  },
  computed: {
    basicValue() {
      return atob(this.localValue).split(':');
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea-counted {
  box-shadow: none;
  padding: 6px 12px;
  height: 38px;
  border-color: #ced4da;
  color: #495057;
  width: 100%;
  border-style: solid;

  &:focus {
    box-shadow: 0 0 0 3.2px rgba(21, 130, 216, 0.25);
    border-color: #7abdf2;
    outline: none;
  }

  &:disabled {
    background-color: #EFEFF0;
  }
}

.basic-output {
  margin-top: 8px;
  padding: 8px;
  border-radius: 4px;
  background-color: #cfddeb;
}
</style>